var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeleteBin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 4.99999H18.3334V6.66666H16.6667V17.5C16.6667 17.9602 16.2936 18.3333 15.8334 18.3333H4.16669C3.70645 18.3333 3.33335 17.9602 3.33335 17.5V6.66666H1.66669V4.99999H5.83335V2.49999C5.83335 2.03976 6.20645 1.66666 6.66669 1.66666H13.3334C13.7936 1.66666 14.1667 2.03976 14.1667 2.49999V4.99999ZM15 6.66666H5.00002V16.6667H15V6.66666ZM7.50002 3.33332V4.99999H12.5V3.33332H7.50002Z",
    fill: "#FF2727"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteBin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-bin.1df1d89e.svg";
export { ForwardRef as ReactComponent };